module.exports = __webpack_public_path__ + "img/ic-menu.44a5e422.svg";